const defaultState = [];

const fontsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'FONTS_LOADED': {
      return [...action.fonts];
    }
    default:
      return state;
  }
};

export default fontsReducer;
